export default __webpack_public_path__ + "static/media/igor.79f6eab6.png";